module.exports = __webpack_public_path__ + "img/icon-click-modal.0f448c0c.svg";